module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "Basic-Text-Frame"
  }, [_c('h1', {
    staticClass: "Prelim-head",
    attrs: {
      "id": "_idParaDest-3"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor002"
    }
  }), _vm._v("Dedication")]), _vm._v(" "), _c('p', {
    staticClass: "Prelim-text"
  }, [_vm._v("All my family.")]), _vm._v(" "), _c('p', {
    staticClass: "Prelim-text"
  }, [_vm._v("Sowe Valley Primary School, Coventry.")]), _vm._v(" "), _c('p', {
    staticClass: "Prelim-text"
  }, [_vm._v("Richard Lee Primary School, Coventry.")]), _vm._v(" "), _c('p', {
    staticClass: "Prelim-text"
  }, [_vm._v("Penny Markley.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7943d972","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9781528954297_EPUB-3.vue
// module id = 66
// module chunks = 0